// Format date ISO to DD-MM-YYYY
export const fmtDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2,'0')}-${String(d.getMonth()+1).padStart(2,'0')}-${d.getFullYear()}`;
};

export const statusMapToApp = {
  "1": "on_planning",
  "2": "on_progress",
  "3": "waiting_approval",
  "4": "on_hold",
  "5": "done"
};

export const statusMapToApi = {
  "on_planning": "1",
  "on_progress": "2",
  "waiting_approval": "3",
  "on_hold": "4",
  "done": "5"
};

// Avatar color palette
export const avatarColors = [
  'linear-gradient(135deg,#f97316,#ea580c)',
  'linear-gradient(135deg,#6366f1,#4338ca)',
  'linear-gradient(135deg,#14b8a6,#0d9488)',
  'linear-gradient(135deg,#ec4899,#db2777)',
  'linear-gradient(135deg,#10b981,#059669)',
  'linear-gradient(135deg,#f59e0b,#d97706)',
  'linear-gradient(135deg,#8b5cf6,#7c3aed)',
  'linear-gradient(135deg,#ef4444,#dc2626)',
];

// Progress bar color helper
export const getProgressColor = (pct) => {
  if (pct === 100) return { bar: 'linear-gradient(90deg, #10b981, #059669)', text: '#059669' };
  if (pct >= 70)  return { bar: 'linear-gradient(90deg, #6366f1, #4338ca)', text: '#6366f1' };
  if (pct >= 40)  return { bar: 'linear-gradient(90deg, #f59e0b, #d97706)', text: '#d97706' };
  if (pct > 0)    return { bar: 'linear-gradient(90deg, #f97316, #ea580c)', text: '#ea580c' };
  return { bar: 'linear-gradient(90deg, #e2e8f0, #cbd5e1)', text: '#94a3b8' };
};

// Tag badge colors (for CategoryCard)
export const tagColors = {
  Infrastruktur: { bg: '#fff7ed', text: '#c2410c' },
  Teknologi:    { bg: '#ede9fe', text: '#6d28d9' },
  Konstruksi:   { bg: '#f0fdfa', text: '#0f766e' },
  Kreatif:      { bg: '#fdf2f8', text: '#be185d' },
  Pemasaran:    { bg: '#fffbeb', text: '#b45309' },
  SDM:          { bg: '#f0fdf4', text: '#166534' },
  Teknik:       { bg: '#f1f5f9', text: '#334155' },
  Khusus:       { bg: '#f5f3ff', text: '#6d28d9' },
};
